<template>
    <div class="elec_bwg_manage">
        <div class="elec_battery_right">
            <div class="battery_right_cnt">
                <div class="elec_title">{{ $t('bwgPowerManage.bwg') }}</div>
                <!-- <div class="battery_right_btn">
                    <div v-for="item in nbqList" :key="item.point_id" :class="[pscItem.point_id == item.point_id ? 'change_item change_item_s' : 'change_item change_item_us']" @click="changePSC(item)">
                        {{item.point_name}}
                    </div>
                </div> -->
                <div class="bottom_cnt">
                    <div class="right_inner_title">
                        <img src="../../../assets/image/custom/battery_elec_icon.png" style="width: 2rem;height: 2rem;"/>
                        <div class="right_title_name">
                            <div class="right_title_name_left">{{curPoint && curPoint.bwg_name}}</div>
                        </div>
                    </div>
                    <el-scrollbar style="height: calc(100% - 2rem); ">
                        <div class="four_table">
                            <!-- <div class="four_table_inner" v-for="(item, index) in pscList" :key="index">
                                <div class="left">{{item.name}}</div>
                                <div class="right">{{item.data}}&nbsp;{{item.unit}}</div>
                            </div> -->
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.dianya') }}</div>
                                <div class="right"><i class="red">A:</i>{{curPoint && curPoint.v_a}}V <i class="green">B:</i>{{curPoint && curPoint.v_b}}V <i class="yellow">C:</i>{{curPoint && curPoint.v_c}}V</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.gonglvyinshu') }}</div>
                                <div class="right">{{curPoint && curPoint.pf}}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.dianliu') }}</div>
                                <div class="right"><i class="red">A:</i>{{curPoint && curPoint.a_a}}A <i class="green">B:</i>{{curPoint && curPoint.a_b}}A <i class="yellow">C:</i>{{curPoint && curPoint.a_c}}A</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.elec_day') }}</div>
                                <div class="right">{{curPoint && curPoint.elecDay}}{{curPoint && curPoint.dayUnit}}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.yougonggonglv') }}</div>
                                <div class="right">{{curPoint && curPoint.p}}{{curPoint && curPoint.p_unit}}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.elec_month') }}</div>
                                <div class="right">{{curPoint && curPoint.elecMonth}}{{curPoint && curPoint.monthUnit}}</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.wugonggonglv') }}</div>
                                <div class="right">{{curPoint && curPoint.q}}kvar</div>
                            </div>
                            <div class="four_table_inner">
                                <div class="left">{{ $t('bwgPowerManage.elec_year') }}</div>
                                <div class="right">{{curPoint && curPoint.elecYear}}{{curPoint && curPoint.yearUnit}}</div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
            <div class="battery_right_cnt">
                <div class="elec_title">{{ $t('bwgPowerManage.shunshifenxi') }}</div>
                <div class="battery_right_btn">
                    <div v-for="item in radioButtons"
                        :key="item.point_class_column_kind_id" 
                        :class="[cur_point_class_column_kind_id == item.point_class_column_kind_id ? 'change_item change_item_s' : 'change_item change_item_us']" 
                        @click="changePSC(item)">
                        {{ item.kind_name }}
                    </div>
                </div>
                <div class="bottom_cnt" style="top: 19%; height: 76%;">
                    <el-form label-width="60px" :model="searchForm" class="leader-style-form">
                        <el-row>
                            <el-col :span="18">
                                <el-form-item :label="$t('photovoltaicPower.time')">
                                    <el-date-picker
                                        v-model="searchForm.from_date"
                                        type="date"
                                        :placeholder="$t('photovoltaicPower.daySelection')"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="disableDate"
                                        :clearable="false"
                                        :editable="false"
                                    ></el-date-picker>
                                    <span style="color: #fff;display: inline-block; padding: 0 20px">{{ $t('photovoltaicPower.zhi') }}</span>
                                    <el-date-picker
                                        v-model="searchForm.to_date"
                                        type="date"
                                        :placeholder="$t('photovoltaicPower.daySelection')"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="disableDate"
                                        :clearable="false"
                                        :editable="false"
                                    ></el-date-picker>
                                    <el-button
                                        type="primary"
                                        size="medium"
                                        @click="search"
                                        icon="el-icon-search"
                                    ></el-button>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6" style="text-align: right;">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="doOpen1"
                                >放大</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="changeTable(false)"
                                >{{ $t('photovoltaicPower.data') }}</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    @click="changeTable(true)"
                                >{{ $t('photovoltaicPower.chart') }}</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="jiaoliu_chart">
                        <div
                            class="echart-container"
                            v-if="this.tableSwitch"
                            v-loading="loading"
                            element-loading-text="loading"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <v-chart :auto-resize="true" :options="lineRight1" ref="lineRight1" />
                        </div>
                        <div class="table-container" v-if="!this.tableSwitch">
                            <el-table
                                :data="tableData"
                                border
                                v-loading="Tloading"
                                height="100%"
                                class="leader-style-table"
                            >
                                <el-table-column
                                    v-for="val in tableHeader"
                                    :key="val.column_val"
                                    :prop="val.column_val"
                                    :label="val.column_key"
                                    align="center"
                                ></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom_rec">
            <div class="bottom_item_div" @mouseenter="hover(1, true)" @mouseleave="hover(1, false)" @click="goRouter(1)">
                <img v-if="selectedBottom == 1" src="../../../assets/image/custom/elec_bottom1_s.png" />
                <img v-else src="../../../assets/image/custom/elec_bottom1_us.png" />
                <div>组件总览</div>
            </div>
            <div class="bottom_item_div" @mouseenter="hover(2, true)" @mouseleave="hover(2, false)" @click="goRouter(2)">
                <img v-if="selectedBottom == 2" src="../../../assets/image/custom/elec_bottom2_s.png" />
                <img v-else src="../../../assets/image/custom/elec_bottom2_us.png" />
                <div>逆变器</div>
            </div>
            <div class="bottom_item_div" @mouseenter="hover(3, true)" @mouseleave="hover(3, false)" @click="goRouter(3)">
                <img v-if="selectedBottom == 3" src="../../../assets/image/custom/elec_bottom3_s.png" />
                <img v-else src="../../../assets/image/custom/elec_bottom3_us.png" />
                <div>并网柜</div>
            </div>
        </div>
        <NbqInstantModule :curPoint="curPoint" :dialogStatus.sync="dialogStatus1" :searchForm="searchForm" @closeDiaCb="closeDiaCb1"></NbqInstantModule>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";

import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import * as api from "@/http/api.js";
import { getDataAll } from "@/http/http-60.js";
import { dayTransfer, monthTransfer } from "@/utils/dateTransfer.js";
import NbqInstantModule from "../bwg/nbq_instant_module.vue";
import unitUtils from "@/utils/unit-exchange.js";
import dayjs from "dayjs";
export default {
    components: {
        NbqInstantModule,
    },
    data() {
        return {
            dialogStatus1: false,
            selectedBottom: '',
            curPoint: null,
            radioButtons: [],
            searchForm: {
                from_date: dayjs().format('YYYY-MM-DD'),
                to_date: dayjs().format('YYYY-MM-DD'),
            },
            cur_point_class_column_kind_id: '',
            pscItem: '',
            pscList: [],
            batteryNameList: [],
            type: 1,
            nbqList: [],
            batteryList: [],
            loading: null,
            overLoading: null,
            timer: null,
            point_ids: [],
            x_list: [],
            series: [],
            legend: [],
            tableHeader: [],
            unit: '',
            tableData: [],
            tableSwitch: true,
            x_list2: [],
            series2: [],
            legend2: [],
            tableHeader2: [],
            unit2: '',
            tableData2: [],
            tableSwitch2: true,
            routerL: 1,
        };
    },
    async mounted() {
        const queryData = this.$route.query;
        this.curPoint = {
            point_id: queryData.point_id, 
            point_60_id: queryData.point_60_id, 
            bwg_name: queryData.bwg_name
        };
      //  if(!this.curPoint.hasOwnProperty('a_a')) {
            this.getDetailData();
       // }
        await this.getPointColumnKinds(this.curPoint.point_id);
        this.setTimer();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                if(this.pscItem && this.pscItem.point_id) {
     
                }
            }, 60000);
        },
        goRouter(num) {
            if(num == 1) {
                this.$router.push({ name:'roof_manage' })
                sessionStorage.setItem("activeTab", "/roof_manage")
            } else if(num == 2) {
                this.$router.push({ name:'nbq_list' })
                sessionStorage.setItem("activeTab", "/nbq_list")
            }  else if(num == 3) {
                this.$router.push({ name:'bwg_manage' })
                sessionStorage.setItem("activeTab", "/bwg_manage")
            }
        },
        hover(item, shown) {
            if(shown) this.selectedBottom = item;
            else this.selectedBottom = '';
        },
        doOpen1() {
            this.dialogStatus1 = true;
        },
        changeTable(showChart) {
            this.tableSwitch = showChart;
        },
        getDetailData() {
            api.getElecInfo({
                point_id: this.curPoint.point_id,
                date: dayjs(new Date()).format("YYYY-MM-DD")
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.curPoint['elecDay'] = res.bus_json.active_power_day;
                    this.curPoint['elecMonth'] = res.bus_json.active_power_month;
                    this.curPoint['elecYear'] = res.bus_json.active_power_year;
                    this.curPoint['dayUnit'] = res.bus_json.dayUnit;
                    this.curPoint['monthUnit'] = res.bus_json.monthUnit;
                    this.curPoint['yearUnit'] = res.bus_json.yearUnit;
                }
            });
            let pointIds=[];
            pointIds.push(this.curPoint.point_60_id);
            getDataAll(pointIds).then(res => {
                if (undefined !== res.bus_json) {
                    let valueJson = res.bus_json;
                    let point = valueJson[this.curPoint.point_60_id];
                    this.curPoint['a_a'] = point && point.a_a;
                    this.curPoint['a_b'] = point && point.a_b;
                    this.curPoint['a_c'] = point && point.a_c;
                    this.curPoint['v_a'] = point && point.v_a;
                    this.curPoint['v_b'] = point && point.v_b;
                    this.curPoint['v_c'] = point && point.v_c;
                    this.curPoint['p'] = unitUtils.exchangeUnitKW(point.p).num;
                    this.curPoint['p_unit'] = unitUtils.exchangeUnitKW(point.p).unit;
                    this.curPoint['q'] = point && point.q;
                    this.curPoint['pf'] = point && point.pf;
                }
            });
        },
        async search() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            await this.getRealTimeData1(this.cur_point_class_column_kind_id);
            loading.close();
        },
        async getPointColumnKinds(point_id) {
            await api.getPointColumnKinds({ point_id: point_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.radioButtons = res.bus_json;//.filter(item => item.point_class_column_kind_id == '1689909850420715530' || item.point_class_column_kind_id == '1689909850420715531');
                    this.cur_point_class_column_kind_id = this.radioButtons && this.radioButtons.length && this.radioButtons[0].point_class_column_kind_id;
                    this.getRealTimeData1(this.cur_point_class_column_kind_id);
                }
            });
        }, 
        async getRealTimeData1(point_class_column_kind_id) {
            if(!point_class_column_kind_id) return;
            this.loading = true;
            await api.getRealTimeData({
                from_date: this.searchForm.from_date,
                to_date: this.searchForm.to_date,
                point_id: this.curPoint.point_id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.x_list;
                    // 数据
                    this.series = [];
                    // 图例
                    this.legend = [];

                    // 表格头部
                    this.tableHeader = [
                        {
                            column_key: this.$t('photovoltaicPower.collectTime'),
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit = item.column_unit;
                        this.legend.push(item.column_desc);
                        this.series.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader.push(header_obj);
                    });

                    //  表格
                    this.tableData = [];
                    this.x_list.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData.push(data_obj);
                    });
                    // setTimeout(() => {
                    // loading.close();
                    this.loading = false;
                    // }, 5000)

                }
            });
        },
        async changePSC(item) {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            this.cur_point_class_column_kind_id = item.point_class_column_kind_id;
            await this.getRealTimeData1(this.cur_point_class_column_kind_id);
            loading.close();
        },
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        lineRight1() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                // legend: {
                //     data: this.legend,
                //     textStyle: {
                //         color: "#fff"
                //     }
                // },
                calculable: true,
                xAxis: {
                    data: this.x_list,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                       // rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: this.unit,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: '#fff' //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' //颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "6%",
                    right: "6%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                series: this.series,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.elec_bwg_manage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 2rem;
    //border: 1px solid red;
    background: url("../../../assets/image/custom/energy_bwg_bac.png") no-repeat left 100%;
    background-size: 50% auto;
    position: relative;
    .bottom_rec {
        position: absolute;
        top: calc(100% - 2.5rem);
        left: 0;
        width: 100%;
        height: 5rem;
      //  border: 1px solid red;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        .bottom_item_div {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            div {
                font-size: 1rem;
                background: linear-gradient(to bottom, #fff 60%, rgba(109, 191, 255, 1) 90%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
            img {
                height: 4.5rem;
                width: auto;
                margin: 0 0 0 1.5rem;
            }
        }
    }
    .el-carousel {
        height: 100%;
        .el-carousel__container {
            height: 100%;
        }
        .el-carousel__arrow {
            width: 2rem;
            height: 2rem;
        }
    }
    .leader-style-form {
        // display: flex;
        // justify-content: end;
    }
    .leader-style-form .el-button {
        color: #fff;
        border: 1px solid #1876d3;
        border-radius: 0.3rem;
        margin: 0 0 0 0.3rem !important;
    }
    .elec_battery_right {
       // border: 1px solid red;
        width: 56%;
        height: calc(100% - 2.5rem);
        margin-left: 44%;
        box-sizing: border-box;
        .battery_right_cnt {
            width: 100%;
            height: 49%;
            margin-bottom: 1%;
            background: url("../../../assets/image/custom/dianchi_rect.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .four_table {
                width: 90%;
                margin-left: 5%;
                height: 90%;
                display: inline-flex; 
                flex-flow: row wrap;
                .four_table_inner {
                    //border: 1px solid blue;
                    width: 50%;
                   // height: 2rem;
                    min-height: 2rem;
                    text-align: center;
                   // line-height: 2rem;
                    font-size: 0.9rem;
                    border-bottom: 1px dotted rgba(24, 47, 76, 1);
                    display: inline-flex;
                    align-items: center;
                    .left {
                        width: 20%;
                        color: rgba(204, 227, 255, 1);
                        text-align: left;
                        font-size: 0.75rem;
                    }
                    .right {
                        flex: 1;
                        color: rgba(255, 255, 255, 1);
                        text-align: right;
                        font-size: 0.75rem;
                        margin-right: 15%;
                    }
                    // &:nth-child(4n + 1) {
                    //     background-color: red;
                    // }
                    &:nth-child(2n + 1) {
                        color: rgba(148, 194, 232, 1);
                    }
                }
            }
            .elec_title {
                position: absolute;
                top: 2.6%;
                left: 8%;
                color: rgba(148, 194, 232, 1);
                font-size: 0.8rem;
            }
            .bottom_cnt {
               // border: 1px solid red;
                position: absolute;
                top: 15%;
                left: 2rem;
                width: calc(100% - 4rem);
                height: 80%;
                box-sizing: border-box;
                color: rgba(148, 194, 232, 1);
                font-size: 0.8rem;
                .jiaoliu_chart {
                    width: 100%;
                   // border: 1px solid red;
                    height: calc(100% - 2rem);
                    .table-container {
                        width: 100%;
                        height: 100%;
                    }
                    .echart-container {
                        width: 100%;
                        height: 100%;
                        .echarts {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .right_inner_title {
                    width: 100%;
                    display: inline-flex;
                    align-items: center;
                }
                .right_title_name {
                    border-bottom: 1px solid rgba(19, 125, 254, 0.3);
                    width: calc(100% - 3rem);
                    margin-left: 1rem;
                    position: relative;
                    height: 1.4rem;
                    .right_title_name_left {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 1.4rem;
                        line-height: 1.4rem;
                        width: 35%;
                        border-bottom: 2px solid rgba(19, 125, 254, 1);
                    }
                }
            }
            .battery_right_btn {
                position: absolute;
                top: 2%;
                right: 0;
                width: 75%;
            height: 1.5rem;
               // margin-left: 20%;
                //height: 3rem;
               // border: 1px solid red;
                display: inline-flex;
            flex-flow: row wrap;
                align-items: center;
                justify-content: flex-end;
            overflow-x: auto;
                .change_item {
                    width: auto;//3.5rem;
                    height: 1.1rem;
                    line-height: 1.1rem;
                    font-size: 0.65rem;
                    text-align: center;
                    cursor: pointer;
                    margin-right: 0.3rem;
                    padding: 0 0.2rem;
                margin-bottom: 0.3rem;
                }
                .change_item_s {
                    color: #fff;
                    border: 1px solid #1876d3;
                   // background-color: rgba(148, 194, 232, 1);
                   // border-radius: 5px;
                }
                .change_item_us {
                    color: #a3a2a2;
                    border: 1px solid #1876d3;
                }
            }
        }
    }
    .chunenggui {
        cursor: pointer;
        display: inline-flex;
        flex-flow: column;
        img {
            width: 12rem;
        }
        .chunenggui_name {
            height: 3rem;
            line-height: 3rem;
            text-align: center;
            font-size: 0.9rem;
            color: #fff;
        }
        .chunenggui_name_s {
            background: url("../../../assets/image/custom/chunenggui_name_s.png") no-repeat;
        }
        .chunenggui_name_us {
            background: url("../../../assets/image/custom/chunenggui_name_us.png") no-repeat;
        }
    }
    .chunenggui1 {
        position: absolute;
        top: 68%;
        left: 3.5%;
    }
    .chunenggui2 {
        position: absolute;
        top: 68%;
        left: 30.2%;
    }
    .elec_battery_right {

    }
    .el-carousel__arrow {
        background-color: rgba(148, 194, 232, 1);
    }
    .el-carousel__arrow--left {
        left: 0;
    }
    .el-carousel__arrow--right {
        right: 0;
    }
    .red {
        color: red;
    }
    .green {
        color: green;
    }
    .yellow {
        color: yellow;
    }
}
</style>
